import StyledSpinner from "./StyledSpinner";

type StyledMainActionButtonProps = {
  onClick: () => void;
  text: string;
  isLoading?: boolean;
  disabled?: boolean;
  type?: "button" | "submit";
};

export const StyledMainActionButton = ({
  onClick,
  text,
  isLoading = false,
  disabled = false,
  type = "button",
}: StyledMainActionButtonProps) => {
  return (
    <button
      type={type}
      disabled={isLoading || disabled}
      onClick={onClick}
      className="bg-brand700 hover:bg-brand600 h-fit w-full rounded-lg px-4 py-3 text-base font-semibold text-white disabled:bg-gray-200"
    >
      {isLoading ? <StyledSpinner width="20" height="20" /> : text}
    </button>
  );
};
